<template lang="pug">
  #costosausteridad
    a.dark-logo(href="https://datacivica.org" rel="noreferrer" target="_blank")
      img(src="/assets/img/Logo_DC_Blanco.png" alt="logo de data civica")
    .social-media.mt-2
      a.mx-2(href="https://twitter.com/datacivica" rel="noreferrer" target="_blank")
        img(src="/assets/img/Icono_Twitter.svg" alt="icono de twitter")
      a.mx-2(href="https://www.facebook.com/datacivica/" rel="noreferrer" target="_blank")
        img(src="/assets/img/Icono_FB.svg" alt="icono de facebook")
      a.mx-2(href="https://www.instagram.com/datacivica/" rel="noreferrer" target="_blank")
        img(src="/assets/img/Icono_Instagram.svg" alt="icono de instagram")
    AusteridadStatic
    Bloques
</template>
<script>
import NavbarDark from "@/components/NavbarDark.vue";
import AusteridadStatic from "@/components/costosa-austeridad/AusteridadStatic.vue";
import Bloques from "@/components/costosa-austeridad/Bloques.vue";

export default {
  name: "CostosaAusteridad",
  components: {
    NavbarDark,
    AusteridadStatic,
    Bloques
  }
};
</script>
<style lang="scss" scoped>
#costosausteridad {
  background-color: #2e2d4d;
  color: #e4e3d2;
  font-family: "Work Sans", sans-serif;
  .dark-logo img {
    max-width: 170px;
    position: absolute;
    top: 0rem;
    left: 0rem;
    padding: 1rem;
    z-index: 100;
    &:hover {
      cursor: pointer;
    }
  }
  .social-media {
    position: absolute;
    top: 0rem;
    right: 0rem;
    padding: 1rem;
    z-index: 100;
    img {
      color: #fff;
      width: 1.3rem;
    }
  }
}

@media (min-width: 992px) {
  #costosausteridad {
    .dark-logo img {
      max-width: 240px;
    }
    .dark-logo img,
    .social-media {
      position: fixed;
      top: 0;
    }
  }
}
</style>
